import React from "react";

import ReactOnRails from "react-on-rails";

// Configure ReactOnRails to use Turbo's lifecycle events
// for mounting and unmounting components, instead of the default DOMContentLoaded.
ReactOnRails.setOptions({
  turbo: true,
  traceTurbolinks: process.env.NODE_ENV !== "production", // Optional: for debugging
});

// Define a more specific type for Webpack's `module` object with HMR properties.
interface HotModule {
  hot?: {
    accept(dependencies: string[], callback: (updatedDependencies: string[]) => void): void;
    accept(dependency: string, callback: () => void): void;
    accept(errHandler?: (err: Error) => void): void;
    dispose(callback: (data: any) => void): void;
    status(): string;
  };
}

type Components = Record<string, React.ComponentType<any>>;

export default {
  /**
   * A wrapper around the base ReactOnRails.register function that handles
   * Hot Module Replacement (HMR) using React Fast Refresh in development.
   * @param components - An object where keys are component names and values are the components.
   * @param fromModule - The `module` object from the calling file, used for HMR.
   */
  register(components: Components, fromModule: HotModule) {
    // Register components with ReactOnRails
    ReactOnRails.register(components);

    // Enable HMR in development
    if (fromModule?.hot && process.env.NODE_ENV !== "production") {
      fromModule.hot.accept();

      fromModule.hot.dispose(() => {
        // Clean up any module-level resources if needed
      });
    }
  },
};
